module.exports = __webpack_public_path__ + "media/stylesheets/images/section_img_2-68ad714c5a06a4d7d12de3fc47acbe30.jpg";